import { FieldValues, UseControllerProps, useFormState } from "react-hook-form";

interface Props<TFieldValues extends FieldValues> {
  control: UseControllerProps<TFieldValues>["control"];
}

function GlobalError<TFieldValues extends FieldValues>({
  control,
}: Props<TFieldValues>) {
  const { errors } = useFormState({ control });

  // ở đây mình lấy lỗi "global" từ superRefine
  const globalError = errors.global?.message as string | undefined;

  return <div className="text-error_main text-xs">{globalError}</div>;
}

export { GlobalError };
